import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUser } from 'src/app/hooks/useUser';
import { useThemeMediaQuery } from '@fuse/hooks';
import NewsList from '../news/NewsList';
import BirthdayList from './components/BirthdayList';
import EmployeesList from './components/EmployeesList';
import GreetingsDialog from 'app/shared-components/greetingsDialog/GreetingsDialog';
import AbsentList from './components/AbsentList';
import './swiper-custom.css';
import 'swiper/css';
import 'swiper/css/navigation';

function HomeApp() {
  const { t } = useTranslation('translations');
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));
  const { isTop } = useUser();

  return (
    <div className="min-w-0 w-full min-h-full h-auto px-10">
      <Grid
        container
        sx={{ flexDirection: { lg: 'row', xs: 'column-reverse' } }}
        spacing={2}
        pt={2}
      >
        <Grid item lg={9} md={12}>
          {/* {isTop && !isMobile && (
            <div className="text-center">
              <SkudCharts />
              <span className="text-center mt-10 text-20 px-16 py-10 bg-white dark:bg-dark  rounded-12 shadow-1">
                {t('CompanyNews', 'Kompaniya yangiliklari')}
              </span>
            </div>
          )} */}
          <NewsList />
        </Grid>
        <Grid item lg={3} md={12}>
          <Grid
            container
            spacing={1}
            sx={{ flexDirection: { lg: 'column', md: 'row', xs: 'column' } }}
          >
            {(() => {
              const now = new Date();
              const showSticker = now.getMonth() === 6 && now.getDate() === 29;
              return showSticker ? (
                <Grid item lg={12} md={6} xs={12}>
                  <img className="w-full" src="assets/images/happy_bday.png" alt="Happy Birthday" />
                </Grid>
              ) : null;
            })()}
            <Grid item lg={12} md={6} xs={12}>
              <BirthdayList />
            </Grid>
            <Grid item lg={12} md={6} xs={12}>
              <EmployeesList />
            </Grid>
            <Grid item lg={12} md={6} xs={12}>
              <AbsentList />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <GreetingsDialog />
    </div>
  );
}

export default HomeApp;
